<template>
  <i :class="['graph-icon', name]"></i>
</template>

<script>
export default {
  name: 'AppGraphIcon',
  status: 'prototype',
  release: '1.0.0',
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.graph-icon {
  display: inline-block;
  background-image: url('../../assets/graph-icons.png');
  background-repeat: no-repeat;
  width: 50px;
  height: 39px;

  &.bars-doble-horizontal {
    background-position: -5px -5px;
  }
  &.bars-doble-horizontal:hover {
    background-position: -5px -54px;
  }
  &.bars-doble-line-vertical {
    background-position: -5px -103px;
  }
  &.bars-doble-line-vertical:hover {
    background-position: -5px -152px;
  }
  &.bars-doble-vertical {
    background-position: -5px -201px;
  }
  &.bars-doble-vertical:hover {
    background-position: -5px -250px;
  }
  &.bars-horizontal {
    background-position: -5px -299px;
  }
  &.bars-horizontal:hover {
    background-position: -5px -348px;
  }
  &.bars-line-vertical {
    background-position: -5px -397px;
  }
  &.bars-line-vertical:hover {
    background-position: -5px -446px;
  }
  &.bars-triple-horizontal {
    background-position: -5px -495px;
  }
  &.bars-triple-horizontal:hover {
    background-position: -5px -544px;
  }
  &.bars-triple-vertical {
    background-position: -5px -593px;
  }
  &.bars-triple-vertical:hover {
    background-position: -5px -642px;
  }
  &.bars-vertical {
    background-position: -5px -691px;
  }
  &.bars-vertical:hover {
    background-position: -5px -740px;
  }
  &.circle {
    background-position: -5px -790px;
  }
  &.circle-fill {
    background-position: -5px -839px;
  }
  &.circle-fill:hover {
    background-position: -5px -888px;
  }
  &.circle:hover {
    background-position: -5px -938px;
  }
  &.dots {
    background-position: -5px -987px;
  }
  &.dots-alt {
    background-position: -5px -1036px;
  }
  &.dots-alt:hover {
    background-position: -5px -1085px;
  }
  &.dots:hover {
    background-position: -5px -1134px;
  }
  &.grid {
    background-position: -5px -1183px;
  }
  &.grid:hover {
    background-position: -5px -1232px;
  }
  &.line {
    background-position: -5px -1281px;
  }
  &.line-curve {
    background-position: -5px -1330px;
  }
  &.line-curve:hover {
    background-position: -5px -1379px;
  }
  &.line:hover {
    background-position: -5px -1428px;
  }
  &.lines {
    background-position: -5px -1477px;
  }
  &.lines-curve {
    background-position: -5px -1526px;
  }
  &.lines-curve:hover {
    background-position: -5px -1575px;
  }
  &.lines-doble-fill {
    background-position: -5px -1624px;
  }
  &.lines-doble-fill:hover {
    background-position: -5px -1673px;
  }
  &.lines-fill {
    background-position: -5px -1722px;
  }
  &.lines-fill:hover {
    background-position: -5px -1771px;
  }
  &.lines:hover {
    background-position: -5px -1820px;
  }
  &.lines-triple-fill {
    background-position: -5px -1869px;
  }
  &.lines-triple-fill:hover {
    background-position: -5px -1918px;
  }
  &.map {
    background-position: -5px -1968px;
  }
  &.map:hover {
    background-position: -5px -2018px;
  }
  &.table {
    background-position: -5px -2067px;
  }
  &.table-alt {
    background-position: -5px -2116px;
  }
  &.table-alt:hover {
    background-position: -5px -2165px;
  }
  &.table-green {
    background-position: -5px -2214px;
  }
  &.table-green:hover {
    background-position: -5px -2263px;
  }
  &.table:hover {
    background-position: -5px -2312px;
  }
  &.total {
    background-position: -5px -2361px;
  }
  &.total:hover {
    background-position: -5px -2410px;
  }
}
</style>
